import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

var userState = {
    userName: '',                //用户名
    userAvatar: '',              //头像
    userToken: '',               //登录信息
    userSelfId: '',              //用户id
    loginTimeStamp: '',          //时间戳 设置过期时间
    autoLogin: false,               //自动登录
    hasLogin: false,             // 是否登录  
};

var userInfo = JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')) : {};
var nowTime = new Date().getTime();

var navlistLocation = JSON.parse(localStorage.getItem('navigation')) ? JSON.parse(localStorage.getItem('navigation')) : {};

if (userInfo.hasLogin) {
    // 判断登录是否过期
    if (nowTime - parseInt(userState.loginTimeStamp) >= 30 * 24 * 60 * 60) {
        userState = {
            userName: '',
            userAvatar: '',
            userToken: '',
            userSelfId: '',
            autoLogin: false,
            loginTimeStamp: '',
            hasLogin: false, // 是否登录
        };
    } else {
        userState = userInfo;
        userState.loginTimeStamp = new Date().getTime();
    }
}

var store = new Vuex.Store({
    state: {
        ...userState,
        navlist: navlistLocation
    },
    mutations: {
        login(state, user) {  // 用户登录
            state.userName = user.userName;
            state.hasLogin = true;
            state.userAvatar = user.userAvatar;
            state.userSelfId = user.userSelfId;
            state.userToken = user.userToken;
            state.autoLogin = user.autoLogin;
            state.loginTimeStamp = new Date().getTime();

            localStorage.setItem("userInfo", JSON.stringify({ ...state }));
        },
        setAvatar(state, avatar) {
            state.userAvatar = avatar;
            localStorage.setItem("userInfo", JSON.stringify({ ...state }));
        },
        logout(state) {
            state.userName = "";
            state.hasLogin = false;
            state.userAvatar = "";
            state.userSelfId = "";
            state.userToken = "";
            state.autoLogin = false;
            state.loginTimeStamp = "";

            localStorage.setItem("userInfo", JSON.stringify({ ...state }));
        },
        setNavList(state, navlist) {
            state.navlist = navlist;
            localStorage.setItem(
                "navigation",
                JSON.stringify(navlist)
            );
        }
    },
    getters: {
        getLogin: state => {
            return state.hasLogin;
        }
    }
});

export default store



// WEBPACK FOOTER //
// ./src/store/store.js